import { render, staticRenderFns } from "./GkLogo.vue?vue&type=template&id=6d5f10c0&scoped=true&"
import script from "./GkLogo.vue?vue&type=script&lang=js&"
export * from "./GkLogo.vue?vue&type=script&lang=js&"
import style0 from "./GkLogo.vue?vue&type=style&index=0&id=6d5f10c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5f10c0",
  null
  
)

export default component.exports